import {types} from '../../types';

const setGetKycAction = (payload) => {
    return {
        type: types.common.SET_LIST,
        payload,
      }
}

export {
  setGetKycAction as SetGetKycAction
}